<template>
    <div class="listmain ">
        <h1 class="firTitle">技能详情页</h1>


        <p class="ql-long-7802039">
          <span class="ql-author-7802039 ql-size-9">
      支持用户自定义技能详情页中的功能控件，需要接入方实现OrionISubSkill接口中的方法，推荐继承OrionSimpleSkill类。OrionSimpleSkill中需要实现的Public方法如下：
          </span>
        </p>
        <table style="color:#000000;font-family:-apple-system, system-ui, &quot;font-size:14.6667px;">
            <tbody>
            <tr>
                <td style="background-color:#666666;color:#FFFFFF;font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    返回
                </td>
                <td style="background-color:#666666;color:#FFFFFF;font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    方法描述
                </td>
            </tr>
            <tr>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    void
                </td>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    onLoadData(Activity activity)
                    界面首次加载时加载数据（此时详情页界面可能初始化完成，不建议进行UI操作）
                </td>
            </tr>
            <tr>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    void
                </td>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    onResume(Activity activity)
                    对应Activity的onResume状态，可以进行UI操作 
                </td>
            </tr>
            <tr>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    View
                </td>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    getContainerView()
                    返回功能控件的View 
                </td>
            </tr>
            <tr>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    void
                </td>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    initView(Activity activity)
                    对ContainerView中的子空间进行初始化
                </td>
            </tr>
            <tr>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    boolean
                </td>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    isContainerViewAbove()
                    功能控件展示的位置，true代表在语音指令上面，false 在下面 
                </td>
            </tr>
            <tr>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    void
                </td>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    onDestroy()
                    对应Activity的onDestroy阶段，用于资源回收 
                </td>
            </tr>
            <tr>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    void
                </td>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    setSupportDeviceTips(String tips)
                    接收服务器返回的支持设备tips信息
                </td>
            </tr>
            <tr>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    void
                </td>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    onActivityResult(int requestCode, int resultCode, Intent data)
                    对应Activity的onActivityResult方法，用于接收上一个页面的回调 
                </td>
            </tr>
            <tr>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    void
                </td>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    initExtraData()
                    用户自定义模块需要进行数据请求或处理时调用 
                </td>
            </tr>
            </tbody>
        </table>
        <p class="ql-long-7802039">
          <span class="ql-author-7802039 ql-size-9">
 用户自定义自己的技能之后，需要找到对应功能的type（参照OrionSkillRegister中定义的字段），SubSkill.class是自定义技能的类。然后在接入方的Application（推荐）或OrionSkillActivity被调用之前进行注册，可以参照以下方法：
          </span>
        </p>
        <highlight-code lang="javascript" v-html="">
           <span>
  Map&lt;Integer, Class&lt;? extends OrionISubSkill>> map = new HashMap<>();
 //传入参数type为技能type, SubSkill.class是继承了OrionISubSkill的class类
 map.put(type, SubSkill.class);
 ...
 OrionSdkClient.getInstance().initSubSkill(map);
       </span>
        </highlight-code>
        <p class="ql-long-7802039">
          <span class="ql-author-7802039 ql-size-9">
 或直接调用OrionSkillRegister.getInstance().register(type, SubSkill.class)依次进行注册
          </span>
        </p>
        <h3 class="sedTitle"> 特殊扩展</h3>
        <p class="ql-long-7802039">
          <span class="ql-author-7802039 ql-size-9">
支持用户以Fragment的接入，对界面进行完全自定义。需要宿主继承SDK中的BaseFragment，并依照type对其进行注册。          </span>
        </p>
        <highlight-code lang="javascript" v-html="">
           <span>
 //传入参数type为技能type, Fragment.class是技能Fragment的class类
 OrionSkillRegister.getInstance().register(type, Fragment.class)；
 //传入参数bundle为传递到Fragment中Bundle对象
 OrionSkillRegister.getInstance().register(type, Fragment.class, bundle)；
       </span>
        </highlight-code>

        <p class="ql-long-7802039">
          <span class="ql-author-7802039 ql-size-9">
注意 ：如果存在特殊扩展且对技能列表进行改写时，需要对点击事件进行额外区分。（SkillListBean.DataBean是列表中网络请求到的数据结构中对应的子项，在接口文档中有说明）
          </span>
        </p>
        <highlight-code lang="javascript" v-html="">
           <span>
  OrionSkillRecord record = OrionSkillRegister.getInstance().getSkillRecord(type);
 if (null == record.getFragment()) {
  //传入参数context-Context对象, dataBean是SkillListBean.DataBean的对象
     OrionSkillActivity.start(context, dataBean);
 } else {
     startActivity(ContainsFragmentActivity.getStartIntent(context, record.getFragment(),
             "", true, true, record.getBundle()));
 }
       </span>
        </highlight-code>
    </div>
</template>

<script>
    export default {
        name: ""
    };
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    h1,
    h2,
    h3,
    h4,
    h5 {
        padding: 0;
        margin: 0px;
        font-weight: normal;
    }

    ul,
    li {
        list-style: none;
    }

    .listmain {
        font-size: 14px;
        line-height: 26px;
        .firTitle {
            font-size: 20px;
            color: #1e4d79;
            margin-bottom: 30px;
        }
        .sedTitle {
            font-size: 16px;
            font-weight: bold;
            padding-bottom: 10px;
            border-bottom: 1px solid #f3f3f3;
            margin-bottom: 15px;
            margin-top: 50px;
            &.fir {
                margin-top: 0px;
            }
        }
        .thirdTitle {
            margin-top: 50px;
            font-weight: bold;
            line-height: 30px;
            font-size: 16px;
        }
        .codeTitle {
            font-weight: bold;
            line-height: 26px;
        }
        pre {
            margin-top: 20px;
        }
        img {
            margin: 30px 0;
            width: 100%;
        }
        table,
        table tr th,
        table tr td {
            border: 1px solid #000;
            text-align: center;
        }
        table {
            line-height: 30px;
            width: 100%;
            border-collapse: collapse;
        }
    }

    .el-submenu .el-menu-item {
        min-width: 190px;
        background: #f5f5f5;
    }

    .el-submenu {
        min-width: 190px;
        background: #f5f5f5;
    }

    img {
        margin-top: 30px;
        margin-bottom: 30px;
    }
</style>



// WEBPACK FOOTER //
// src/components/tutor/SDK-android/Skill_detail.vue